import { toPlatePlugin } from 'platejs/react';
import type { Apollo } from 'src/gql/generated';

import { BaseSkillElementPlugin, BaseSkillInputPlugin } from './skill-element-plugin';
import { SkillElement } from '../../ChatEditor/ChatEditorSkill/SkillElement';
import { SkillInputElement } from '../../ChatEditor/ChatEditorSkill/SkillInputElement';

export const SkillElementPlugin = toPlatePlugin(BaseSkillElementPlugin).withComponent(SkillElement);

const SkillInputPlugin = toPlatePlugin(BaseSkillInputPlugin, {
  options: { hasPicker: true },
}).withComponent(SkillInputElement);

/**
 * The `/` skill picker, offering only skills in the given scopes.
 *
 * The element plugin already nests the input plugin, but the input's React component has
 * to be attached separately, so both appear here.
 */
export function createScopedSkillEntityKit(offeredScopes: readonly Apollo.AgentSkillScope[]) {
  return [SkillElementPlugin.configure({ options: { offeredScopes } }), SkillInputPlugin];
}
